import { OptionModel } from 'app/hooks/useOptions'
import {
  BLOG_ARTICLES_PER_PAGE,
  BLOG_SORTING_PARAMS,
  ROOT_CATEGORY_TAB
} from 'app/utils/constants/blog.constants'
import { capitalize } from 'app/utils/helpers/common.helpers'
import { isOfType } from 'app/utils/helpers/type.helpers'

import { WEBSITE_URL } from '../constants/env.constants'

export const isDefaultCategory = (category: string | undefined) =>
  category === ROOT_CATEGORY_TAB.value ||
  isOfType.nil(category) ||
  category === ''

export const hasCategoryInCollection = ({
  category,
  collection
}: {
  category?: string
  collection?: BlogCategoryModel[]
}) =>
  isDefaultCategory(category) ||
  !!collection?.find((item) => item.slug === category)

export const getArticlesQueryParams = (
  params?: BlogUrlSearchParams
): BlogQueryParams => {
  const { category, p } = params || {}

  const baseQueryParams: BlogQueryParams = {
    per_page: BLOG_ARTICLES_PER_PAGE.regular,
    page: Number(p) || 1
  }

  const isDefault = isDefaultCategory(category)

  const requestSearchParams = isDefault
    ? baseQueryParams
    : { by_blog_category: category, ...baseQueryParams }

  return requestSearchParams
}

export const getFeaturedArticlesQueryParams = (): BlogQueryParams => ({
  sorting: BLOG_SORTING_PARAMS.byFeatured,
  per_page: BLOG_ARTICLES_PER_PAGE.featured
})

interface RelevantArticlesParamsConfig {
  slug: string
}

export const getRelevantArticlesQueryParams = ({
  slug
}: RelevantArticlesParamsConfig): BlogQueryParams => ({
  by_excluded_slug: slug,
  per_page: BLOG_ARTICLES_PER_PAGE.relevant
})

interface SearchArticlesByTagParamsConfig {
  tag?: string
  p?: number | string
}

export const getSearchByTagQueryParams = (
  params?: SearchArticlesByTagParamsConfig
): BlogQueryParams => {
  const { tag, p } = params || {}

  return {
    by_blog_tag: tag ?? '',
    page: Number(p) || 1,
    per_page: BLOG_ARTICLES_PER_PAGE.regular
  }
}

interface GenerateArticleLinkConfig {
  slug: string
  categorySlug: string
  asShareLink?: boolean
}
export const generateArticleLink = ({
  slug,
  categorySlug,
  asShareLink = false
}: GenerateArticleLinkConfig) => {
  const link = `/blog/${categorySlug}/${slug}`

  if (asShareLink) return WEBSITE_URL + link

  return link
}

export const convertToBlogOptionModel = (
  options?: BlogTagModel[] | BlogCategoryModel[] | string
): OptionModel[] => {
  if (options === undefined) return []

  if (isOfType.string(options)) {
    return [{ label: capitalize(options), value: options }]
  }

  const blogOptions = options.map((item) => {
    const { name, slug } = item
    const capitalizedLabel = capitalize(name)

    return {
      label: capitalizedLabel,
      value: slug
    }
  })

  return blogOptions
}

export const prependRootTab = (tabs: OptionModel[], rootTab?: OptionModel) => {
  return [rootTab ?? ROOT_CATEGORY_TAB, ...tabs]
}
